<div class="pageheader">
  <div class="page-title">
    <h1>Monitor items</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">
        <span>Refresh</span>
        <ep-svg-icon icon="repeat"></ep-svg-icon>
      </button>
      <button class="btn btn-link" *bizPermissionRequired="'Monitor_Action_Item_Create'"
        (click)="grid.addNewItem()">
        <span>Create new</span>
        <ep-svg-icon icon="plus"></ep-svg-icon>
      </button>
      <app-change-log-link *bizPermissionRequired="'Monitor_Action_ShowLog'" [title]="'Monitor items log'">
        <app-change-log-link-entity type="MonitorItem"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>


<!-- Button bar -->
<div class="row">
  <div class="col-sm-12">
    <div class="form-group btn-toolbar">
      @if (!buttonCanResume) {
        <div class="btn-group">
          <button *bizPermissionRequired="'Monitor_Action_Item_Edit'" class="btn btn-primary btn-sm" (click)="pauseMonitors()" [disabled]="!buttonCanPause">Pause Monitors</button>
        </div>
      }
      @if (buttonCanResume) {
        <div class="btn-group">
          <button *bizPermissionRequired="'Monitor_Action_Item_Edit'" class="btn btn-primary btn-sm" (click)="resumeMonitors()">Resume Monitors</button>
        </div>
      }
    </div>
  </div>
</div>


<app-monitor-items-grid #grid [items]="monitorItems" [groups]="monitorGroups" [schedules]="monitorSchedules"
  [stakeholders]="stakeholders" [artifacts]="artifacts" (deleteItem)="onDeleteItem($event)" (selectedRowsChange)="onSelectedRowChange($event)">
</app-monitor-items-grid>
